import configKeys from '@/util/constants/configKeys';

const state = {
  dollarQuotation: {
    selected: null,
    options: [],
  },
};

const getters = {
  dollarSelected() {
    return state.dollarQuotation.selected;
  },

  dollarOptions() {
    return state.dollarQuotation.options;
  },
};

const actions = {
  async fetchDollarConfig({ commit }) {
    const {
      data: { data },
    } = await this.$services.resource('configurations').show(configKeys.DOLLAR_TYPE);

    commit('SET_DOLLAR_SELECTED', data.value);
    commit('SET_DOLLAR_OPTIONS', data.options);
  },

  async updateDollarConfig({ commit }, value) {
    await this.$services.resource('configurations').update(configKeys.DOLLAR_TYPE, { value });

    commit('SET_DOLLAR_SELECTED', value);
  },
};

const mutations = {
  SET_DOLLAR_SELECTED(state, value) {
    state.dollarQuotation.selected = value;
  },

  SET_DOLLAR_OPTIONS(state, options) {
    state.dollarQuotation.options = options;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
